import React, { useState } from "react";
import Popup from "./PopupWithMessage";
import PhoneInput from "./../PhoneInput/PhoneInput";

const SendButton = ({ disabled }) => (
  <button type="submit" disabled={disabled} className="button popup-footer__button">Отправить</button>
);

const DoctorReviewPopup = ({ name, authenticity_token, doctorId, doctorFullname }) => {
  const [messageShown, setMessageShown] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const [formDisabled, setFormDisabled] = useState(false);

  const hideMessage = () => setMessageShown(false);
  const toggleAgreement = () => setAgreed(!agreed);

  const handleSubmit = e => {
    e.preventDefault();

    setFormDisabled(true);

    const axios = require('axios');
    const url = '/reviews'
    const data = new FormData(e.target);

    axios
      .post(url, data, {headers: {'Accept': 'application/json'}})
      .then(() => setMessageShown(true))
      .finally(() => {
        setFormDisabled(false);
        setAgreed(false);
      })
  };

  return (
    <form onSubmit={handleSubmit} className="new_review" id="new_review" acceptCharset="UTF-8" method="post">
      <input name="utf8" type="hidden" value="✓" />
      <input type='hidden' name='authenticity_token' value={authenticity_token} />
      <input value={doctorId} type="hidden" name="review[reviewable_id]" />
      <input value="Doctor" type="hidden" name="review[reviewable_type]" />
      <Popup
        name={name}
        onHide={hideMessage}
        header="Оставьте свой отзыв о враче"
        footer={<SendButton disabled={formDisabled || !agreed}/>}
        message="Спасибо за отзыв!"
        messageShown={messageShown}
        hideMessage={hideMessage}
      >
        <div className="popup-form">
          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="review_fullname">Ваше имя</label>
            <input className="input-group__input" required name='review[fullname]' />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor="review_email">Электронная почта</label>
            <input className="input-group__input" name='review[email]' type="email" />
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor='review[phone]'>Телефон</label>
            <PhoneInput name='review[phone]'/>
          </div>

          <div className="input-group input-group_indent-b_default">
            <label className="input-group__label" htmlFor='review[body]'>Отзыв</label>
            <textarea className="input-group__textarea" required name='review[body]' />
          </div>

          <div className="input-group">
            <label className="input-group__label input-group__label_checkbox">
              <input type="checkbox" onClick={toggleAgreement} className="input-group__checkbox" required name='agreed' />
              <div className="input-group__checkbox-state" />
              Выражаю согласие на обработку персональных данных в соответствии
              с условиями.
            </label>
          </div>
        </div>
      </Popup>
    </form>
  );
};

export default DoctorReviewPopup;
